import { useMemo } from "react";

import getLayers from "./layers/getLayer";

export function useLegends(layerGroup, subgroup, mapLoaded, layersToggle) {
  const legends = useMemo(() => {
    return getLayers(layerGroup, { floodGroup: subgroup }, layersToggle)
      .legends;
  }, [layerGroup, subgroup, layersToggle]);

  return { legends };
}
